import React from 'react'
import { Card, Text, Grid, TextInput, NumberInput, Flex, Button } from '@mantine/core'
import WholesaleRateCard from './WholesaleRateCard'

const FreightRatePanel = ({ method, rates, onRateChange, onSave, loading }) => {
    const label = method.label
    const value = method.value
    const currentRates = rates[value] || {}
    const unit = value?.includes('ocean') ? 'CBM' : 'kg'

    return (
        <Card withBorder mt="sm" p="lg" radius="md">
            <Text fw={700} mb="md">{label} Rate</Text>
            <Grid>
                <Grid.Col span={3}>
                    <TextInput
                        label={`${label} Currency`}
                        placeholder="USD"
                        value={currentRates.currency || ''}
                        onChange={(e) => onRateChange(value, 'currency', e.target.value)}
                    />
                </Grid.Col>
                <Grid.Col span={3}>
                    <NumberInput
                        label={`${label} Cost`}
                        placeholder="0"
                        value={currentRates.cost}
                        onChange={(val) => onRateChange(value, 'cost', val)}
                        leftSection={<Text size="xs" c="dimmed">{currentRates.currency}</Text>}
                        hideControls
                    />
                </Grid.Col>
                <Grid.Col span={3}>
                    <NumberInput
                        label={`${label} Minimum Value`}
                        placeholder="0"
                        value={currentRates.min_value}
                        onChange={(val) => onRateChange(value, 'min_value', val)}
                        leftSection={<Text size="xs" c="dimmed">{currentRates.currency}</Text>}
                        hideControls
                    />
                </Grid.Col>
                <Grid.Col span={3}>
                    <NumberInput
                        label={unit === 'CBM' ? 'CBM Minimum' : 'Weight Minimum'}
                        placeholder="0"
                        value={currentRates.weight_min}
                        onChange={(val) => onRateChange(value, 'weight_min', val)}
                        rightSection={<Text size="xs" c="dimmed" mr="xs">{unit}</Text>}
                    />
                </Grid.Col>
            </Grid>
            <Grid mt="md">
                <Grid.Col span={3}>
                    <NumberInput
                        label="Step"
                        placeholder=""
                        value={currentRates.step}
                        onChange={(val) => onRateChange(value, 'step', val)}
                        rightSection={<Text size="xs" c="dimmed" mr="xs">{unit}</Text>}
                    />
                </Grid.Col>
                <Grid.Col span={3}>
                    <NumberInput
                        label="Estimated Time of Arrival (ETA)"
                        placeholder=""
                        value={currentRates.eta}
                        onChange={(val) => onRateChange(value, 'eta', val)}
                        rightSection={<Text size="xs" c="dimmed" mr="xs">days</Text>}
                    />
                </Grid.Col>
            </Grid>

            <WholesaleRateCard
                method={value}
                rates={rates}
                onRateChange={onRateChange}
            />

            <Flex justify="flex-end" mt="md">
                <Button onClick={() => onSave(value)} loading={loading}>Save {label} Rates</Button>
            </Flex>
        </Card>
    )
}

export default FreightRatePanel
